import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import { leafHead } from "@/lib/seo/leaf-head";
import { SITE_URL } from "@/lib/seo";
import { ALL_TOOLS, CLUSTERS, CLUSTER_EMOJI, CLUSTER_LABEL, toolsByCluster } from "@/lib/utility-tools/registry";

export const Route = createFileRoute("/tools/all")({
  head: () =>
    leafHead({
      path: "/tools/all",
      title: "50 Free Online Calculators & Utility Tools — DrHint",
      description:
        "Directory of 50 free calculators: TDEE, FIRE, salary, sleep cycles, aspect ratio, pet age, solar battery sizing and more. No sign-up, instant results.",
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Free online calculators and utility tools",
            numberOfItems: ALL_TOOLS.length,
            itemListElement: ALL_TOOLS.map((t, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: t.name,
              url: `${SITE_URL}/tools/${t.slug}`,
            })),
          }),
        },
      ],
    }),
  component: ToolsDirectory,
});

function ToolsDirectory() {
  return (
    <Layout>
      <section className="mx-auto max-w-5xl px-4 py-6">
        <h1 className="text-3xl font-black tracking-tight md:text-4xl">
          50 Free Calculators &amp; Utility Tools
        </h1>
        <p className="mt-3 max-w-3xl text-sm text-muted-foreground">
          Every tool runs instantly in your browser — no sign-up, no download, no data sent anywhere. Pick the
          cluster that matches what you are trying to work out right now.
        </p>

        {CLUSTERS.map((c) => (
          <div key={c} className="mt-8">
            <h2 className="text-lg font-bold">
              {CLUSTER_EMOJI[c]} {CLUSTER_LABEL[c]}
            </h2>
            <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {toolsByCluster(c).map((t) => (
                <Link
                  key={t.slug}
                  to="/tools/$tool"
                  params={{ tool: t.slug }}
                  className="rounded-2xl border border-border bg-card p-4 transition hover:border-primary/60"
                >
                  <div className="text-sm font-bold">{t.name}</div>
                  <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">{t.description}</p>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
    </Layout>
  );
}
